var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeVotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00098 23.9482L8 23.9463L7.99707 23.9385C7.99798 23.9418 8.00009 23.945 8.00098 23.9482ZM19.2529 12.9795L19.2568 12.9844C19.5068 13.3698 19.874 13.6859 20.3232 13.8691L20.5215 13.9395C21.0641 14.1048 21.6443 14.0619 22.1533 13.8252L22.1611 13.8213L22.1699 13.8174L26.292 11.8525L23.3115 22.8027H7.68848L4.70703 11.8525L8.83008 13.8174L8.83789 13.8213C9.28516 14.0321 9.78849 14.0923 10.2734 13.9922L10.4795 13.9395C11.0227 13.7734 11.4643 13.4196 11.749 12.9746L11.748 12.9736L15.499 7.15234L19.2529 12.9795Z",
    stroke: "#FFCC29",
    strokeWidth: 3.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5714 6.83899L11.422 13.3594L3.71606 10.3956L7.86543 24.0292H23.2774L27.4267 10.3956L20.3135 13.3594L15.5714 6.83899Z",
    fill: "#FFCC29",
    stroke: "#FFCC29",
    strokeWidth: 1.9375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeVotesIcon);
export default __webpack_public_path__ + "static/media/freeVotesIcon.6fd0b7a175a2aeb5dd862b8c9d7bc99d.svg";
export { ForwardRef as ReactComponent };